import React, { useState, useEffect, useRef } from "react";
import { useLocation, useHistory, useParams } from "react-router-dom";
// import { Icon } from "@iconify/react";
import axios from "axios";
import {
  Menu,
  Dropdown,
  Button,
  Space,
  Row,
  Col,
  Image,
  Typography,
} from "antd";
import ReactToPrint from "react-to-print";
import { render } from "react-dom";
import GiftVoucher from "../giftVoucher";
import MainButton from "../../../../components/button/mainButton";
import { mdiPrinter } from "@mdi/js";
import Icon from "@mdi/react";
import giftvoucherprint from "../../../../assets/images/GV-05.png";
import { numberWithCommas } from "../../../../helpers/functions";
import moment from "moment";
interface Props {
  ComponentRef?: any;
  title?: string;
  data?: any;
  type?: string;
}

const GiftVoucherPrint: React.FC<Props> = ({
  ComponentRef,
  title,
  data,
  type,
}) => {
  const componentRef = useRef<any>(ComponentRef);
  const x = ["1", "2", "3"];
  const { Text } = Typography;
  const dateFormat = "DD-MM-YYYY";

  return (
    <div>
      {console.log("data print", data)}
      <ReactToPrint
        trigger={() => (
          <MainButton
            background="#4285F4"
            title="พิมพ์/Print"
            // onClick={() => setIsDisabled(true)}
            height="45px"
            width="120px"
          >
            <Icon path={mdiPrinter} size="20" color="#ffff" />
          </MainButton>
        )}
        content={() => componentRef.current}
        bodyClass="print-custom"
        pageStyle="@page {  size: A4 Portrait; }" //
      />
      <div ref={componentRef} className="page-print-custom">
        {data.map((data: any) => {
          return (
            <div
              style={{ position: "relative", width: "795px", height: "562px" }}
            >
              <img
                src={giftvoucherprint}
                width="794px"
                height="561px"
                alt="gift"
              />

              <div
                style={{
                  // backgroundColor: "red",
                  width: "160px",
                  // zIndex: "0",
                  height: "50px",
                  position: "absolute",
                  top: "18px",
                  right: "0px",
                }}
              >
                <Text style={{ fontSize: "12px", color: "#4D7E7F" }} strong>
                  Voucher No. {data.code}
                </Text>
                {/* {data} */}
              </div>
              <div
                style={{
                  // backgroundColor: "red",
                  width: "450px",
                  // zIndex: "0",
                  height: "50px",
                  position: "absolute",
                  top: "290px",
                  right: "0px",
                }}
              >
                <Space
                  direction="horizontal"
                  style={{ width: "100%", justifyContent: "center" }}
                >
                  <Text style={{ fontSize: "24px", color: "#4F4F4F" }} strong>
                    {data.detail}
                  </Text>
                </Space>
                {/* {data} */}
              </div>
              <div
                style={{
                  // backgroundColor: "red",
                  width: "250px",
                  // zIndex: "0",
                  height: "50px",
                  position: "absolute",
                  top: "375px",
                  right: "100px",
                }}
              >
                <Space
                  direction="horizontal"
                  style={{ width: "100%", justifyContent: "center" }}
                >
                  <Text style={{ fontSize: "36px", color: "#FFFFFF" }} strong>
                    {numberWithCommas(data.credit, 0) + ".-"}
                  </Text>
                </Space>
                {/* {data} */}
              </div>
              <div
                style={{
                  // backgroundColor: "red",
                  width: "160px",
                  // zIndex: "0",
                  height: "50px",
                  position: "absolute",
                  top: "510px",
                  right: "0px",
                }}
              >
                <Space
                  direction="horizontal"
                  style={{ width: "100%", justifyContent: "center" }}
                >
                  <Text style={{ fontSize: "14px", color: "red" }}>
                    Exp.
                    {moment(data.endDate.substring(0, 10)).format(dateFormat)}
                  </Text>
                </Space>
                {/* {data} */}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default GiftVoucherPrint;
